import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Paper from '@mui/material/Paper'
import { createUseStyles } from 'react-jss'
import { CustomerAddress, DocumentDate, Footer, Header, theme } from '../../document/Document'

const useStyles = createUseStyles(theme)

const Contract = ({ document_param: contract, company_param: company, logo_param: logo }) => {
  const customer = contract.customer
  const classes = useStyles()

  const References = () => {
    if (contract) {
      return (
        <>
          <Box className={classes.rightContainer}>
            <Typography className={classes.boldWithSpace}>Référence contract</Typography>
            <Typography className={classes.address}>{contract.contract_number}</Typography>
          </Box>
        </>
      )
    }
  }

  const ContractPayment = () => (
    <Box className={classes.mt}>
      <Typography className={classes.conditions}>
        {`Conditions et règlement de paiement : Prélèvement bancaire mensuel fixe à date de souscription`}
      </Typography>
    </Box>
  )

  return (
    <Paper className={classes.paper}>
      <Box className={classes.page}>
        <Header logo={logo} classes={classes} documentTitle={'CONTRAT'} />
        <References />
        <DocumentDate date={contract.contract_date} classes={classes} />
        <CustomerAddress customer={customer} company={company} classes={classes} />
        <ContractPayment />
        <Footer company={company} classes={classes} />
      </Box>
    </Paper>
  )
}

export default Contract
